import React, { useState } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Link,
  Alert,
  CircularProgress,
} from '@mui/material';
import COLORS from '../../theme/colors';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Register = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    displayName: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      return setError('Passwords do not match');
    }

    if (formData.password.length < 6) {
      return setError('Password must be at least 6 characters');
    }

    setLoading(true);

    try {
      await register(formData.email, formData.password, formData.displayName);
      navigate('/');
    } catch (error) {
      setError(error.message || 'Failed to create account');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 8, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: COLORS.background.light }}>
      <Paper elevation={0} sx={{ p: 4, borderRadius: 4, boxShadow: '0 2px 16px rgba(44, 62, 80, 0.08)', maxWidth: 400, width: '100%' }}>
        <Typography variant="h5" fontWeight={600} sx={{ mb: 2, color: COLORS.text.primary, textAlign: 'left' }}>Create Account</Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Full Name"
            name="displayName"
            value={formData.displayName}
            onChange={handleChange}
            required
            margin="normal"
            sx={{ background: COLORS.background.paper, borderRadius: 2, mb: 2 }}
            InputProps={{ sx: { fontSize: 18, color: COLORS.text.primary } }}
            InputLabelProps={{ sx: { fontSize: 16, color: COLORS.text.secondary } }}
          />
          <TextField
            fullWidth
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
            margin="normal"
            sx={{ background: COLORS.background.paper, borderRadius: 2, mb: 2 }}
            InputProps={{ sx: { fontSize: 18, color: COLORS.text.primary } }}
            InputLabelProps={{ sx: { fontSize: 16, color: COLORS.text.secondary } }}
          />
          <TextField
            fullWidth
            label="Password"
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            required
            margin="normal"
            sx={{ background: COLORS.background.paper, borderRadius: 2, mb: 2 }}
            InputProps={{ sx: { fontSize: 18, color: COLORS.text.primary } }}
            InputLabelProps={{ sx: { fontSize: 16, color: COLORS.text.secondary } }}
          />
          <TextField
            fullWidth
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
            margin="normal"
            sx={{ background: COLORS.background.paper, borderRadius: 2, mb: 2 }}
            InputProps={{ sx: { fontSize: 18, color: COLORS.text.primary } }}
            InputLabelProps={{ sx: { fontSize: 16, color: COLORS.text.secondary } }}
          />
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            disabled={loading}
            sx={{ mt: 1, mb: 2, background: COLORS.primary.main, color: COLORS.primary.contrastText, borderRadius: 3, fontWeight: 600, fontSize: 18, boxShadow: 'none', '&:hover': { background: COLORS.primary.dark } }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Register'}
          </Button>
        </form>
        <Typography variant="body2" sx={{ color: COLORS.text.secondary, mt: 2 }}>
          By creating an account you agree to our Terms and Privacy Policy.
        </Typography>
      </Paper>
    </Container>
  );
};

export default Register;
